export default __webpack_public_path__ + "static/media/f4e19294e5ca831b.2b89d0be87d1678e42e791febea129db.svg";